import { Suspense, lazy } from 'react';
import { PageSpinner } from '@/components/ui';

const Login = lazy(() => import('@/features/auth/LoginPage'));
const ChangePassword = lazy(() => import('@/features/auth/ChangePasswordPage'));

export function LoginPageLazy() {
  return (
    <Suspense fallback={<PageSpinner />}>
      <Login />
    </Suspense>
  );
}

export function ChangePasswordPageLazy() {
  return (
    <Suspense fallback={<PageSpinner />}>
      <ChangePassword />
    </Suspense>
  );
}
